import React from "react";
import { Camera as CameraIcon, Video, Mic } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGE_PATH } from "../../api/apiConfig";

/**
 * CameraControls — bottom bar with mode-toggle buttons and upload trigger.
 * Rendered once (was previously duplicated in Camera.jsx).
 */
const CameraControls = ({
	mode,
	isRecording,
	isAudioRecording,
	onSetMode,
	onUploadClick,
	onStopRecording,
}) => {
	const handleUpload = () => {
		if (mode === "video" || isRecording) {
			onSetMode("photo");
			if (isRecording) {
				onStopRecording();
			}
		}
		onUploadClick();
	};

	return (
		<div className="flex w-full items-center justify-center gap-4 rounded-t-2xl border-t border-white/20 bg-black/60 px-4 py-3 backdrop-blur-sm">
			{/* Upload button */}
			<button
				onClick={handleUpload}
				className="cursor-pointer transition-opacity hover:opacity-80"
				title="Upload image"
			>
				<img
					src={`${IMAGE_PATH}/newsfeed/upload.png`}
					alt="Upload"
					className="h-8 w-auto brightness-0 invert"
				/>
			</button>

			{/* Mode toggle */}
			<div className="flex gap-2 rounded-full bg-black/40 p-1 backdrop-blur-sm">
				<Button
					onClick={() => onSetMode("photo")}
					disabled={isRecording || isAudioRecording}
					size="icon"
					className={`flex h-10 w-10 items-center justify-center rounded-full p-0 transition-all [&_svg]:!h-7 [&_svg]:!w-7 ${
						mode === "photo"
							? "bg-white text-black hover:bg-gray-200"
							: "bg-transparent text-white hover:bg-white/10"
					}`}
					title="Photo"
				>
					<CameraIcon size={28} />
				</Button>
				<Button
					onClick={() => onSetMode("video")}
					disabled={isRecording || isAudioRecording}
					size="icon"
					className={`flex h-10 w-10 items-center justify-center rounded-full p-0 transition-all [&_svg]:!h-7 [&_svg]:!w-7 ${
						mode === "video"
							? "bg-white text-black hover:bg-gray-200"
							: "bg-transparent text-white hover:bg-white/10"
					}`}
					title="Video"
				>
					<Video size={28} />
				</Button>
				<Button
					onClick={() => onSetMode("audio")}
					disabled={isRecording || isAudioRecording}
					size="icon"
					className={`flex h-10 w-10 items-center justify-center rounded-full p-0 transition-all [&_svg]:!h-7 [&_svg]:!w-7 ${
						mode === "audio"
							? "bg-white text-black hover:bg-gray-200"
							: "bg-transparent text-white hover:bg-white/10"
					}`}
					title="Audio"
				>
					<Mic size={28} />
				</Button>
			</div>
		</div>
	);
};

export default CameraControls;
